/**
 * Adzuki
 * recipient_selection.js
 */

(function RecipientSelection($, Adzuki)
{
	"use strict";

	// selectors used for instantiating this must be unique.
	// unfortunately, there's no way to reliably get the selector used to create
	// a jQuery object, so i'm only tracking string-based selectors.
	var selectors = [];

	// cache of data for pre-fetched multi-select results
	var cache     = {};

	var data_urls = {
		'cp-insight': '/Searches/recipient/cp-insight///1',
		group       : '/Searches/recipient/group///1',
		segment     : '/Searches/recipient/segment///1',
		// source      : '/Sources/getSources/1',
		source      : '/Searches/recipient/source///1',
	};

	var recipientSelection = function RecipientSelection(el)
	{
		var self = this,
		    $input_field,
		    type,
		    uri,
		    text_client_ids,
		    _selected       = {};
		    // _insert_on_blur = false;

		try
		{
			// enforce 'new' operator to ensure 'this' points to this
			// instance, instead of the global window object.
			// in other Adzuki modules, this is enforced via a thrown Error,
			// but Adzuki.RecipientSelection is not generally assigned to a variable
			// like other Adzuki modules and it wouldn't make sense to throw
			// an Error because no methods are called on it directly,
			// so just return a new instance of this on runtime
			if ((this instanceof RecipientSelection) === false) {
				return new RecipientSelection(el);
			}

			this.$el                  = null;
			this.$multiselect         = null;
			this.$multiselect_toggle  = null;
			this.$recipient_template  = null;
			this.$search_type         = null;
			this.$selected_recipients = null;
			this.multiselect_visible  = false;
			this.search_type          = 'all';
			this.form_name            = 'recipient';
			this.text_recipients      = [];

			if (el instanceof jQuery) {
				this.$el = el;
			}
			else {
				if (selectors.indexOf(el) === -1) {
					selectors.push(el);
				}
				else {
					console.warn('[Adzuki.RecipientSelection] potential duplicate selector detected.');
				}

				this.$el = $(el);
			}

			if (!this.$el.length) {
				throw new Error('cannot find ' + el);
			}

			this.$multiselect         = this.$el.find('.form-group.search select');
			this.$multiselect_toggle  = this.$el.find('a.multiselect-toggle');
			this.$recipient_template  = this.$el.find('.recipient.template');
			this.$search_type         = this.$el.find('select.type');
			this.$selected_recipients = this.$el.find('.selected-recipients');
			$input_field              = this.$el.find('input[type="text"].search');

			if ($input_field.data("form-name")) {
				this.form_name = 'form_component_data[' + $input_field.data("form-name") + '][recipient]';
			}

			if ($input_field.data('selected-recipients')) {
				_selected = $input_field.data('selected-recipients');
			}
			
			if (this.$search_type.length) {
				this.search_type = this.$search_type.val();
			} else {
				this.search_type = this.$el.find('.search-type').val();
			}

			// if there are text recipients, load them up
			if (
				$('.existing-text-recipients').length > 0
				&& $('.existing-text-recipients').val() !== ''
			) {
				text_client_ids = $('.existing-text-recipients').val().split(',');

				$.each(text_client_ids, function onEachRecipient(i, id) {
					self.text_recipients.push(id);
				});

				this._showHideTextRecipients();
			}

			Adzuki.Typeahead(
				$input_field,
				function search(term, display, $self)
				{
					var require_email = 1;
					var add_new_email = 1;

					// _insert_on_blur = false;
					uri = '/Searches/recipient/' + self.search_type + '/' + term;

					if ($self.data('no-email-required') !== undefined) {
						require_email = 0;
					}

					// when searching using an email, if there are no recipients found
					// should we allow the user to insert the email manually?
					if ($self.data('no-new-email') !== undefined) {
						add_new_email = 0;
					}

					uri += '/' + require_email + '/0/' + add_new_email;

					Adzuki.Ajax.get(uri)
					.then(function searchDisplay(response)
					{
						$self.removeClass('ajax-spinner');
						display(response);
						if (
							response.length === 1
							&& response[0].status === 'no_results'
						) {
							self.$el.trigger('adz.recipients.no-results');
						}

						// in the case where an email address is not in our db,
						// we allow them to manually select it as a recipient.
						// this tracks state so when people don't explicitly click
						// the "no results found, click to use x" we can do it automatically.
						// if (response.length === 1) {
						// 	if (response[0].status === 'insert_email') {
						// 		_insert_on_blur = true;
						// 	}
						// }
					})
					.catch(function searchError()
					{
						$self.removeClass('ajax-spinner');
						display([{name: "Error searching for recipients."}]);
					});
				},
				function select(item, $self, context)
				{
					const hasHighlight = context.$el.closest('.client-highlight').length > 0;

					var type,
					    label,
					    item_id,
						score;

					if (item.status && item.status === 'insert_email') {
						type    = 'manual_email';
						item_id = item.email;
						label   = item.email;
					}
					else if (item.id === undefined) {
						$self.val('');
						return;
					}
					else {
						type    = item.type.toLowerCase().replace(/\s/g, '-');
						item_id = item.id;
						label   = '<b>' + Adzuki.String.ucwords(type.replace('_', ' ')) + ':</b> ' + item.name;
						score   = item.score;

					}

					if (_selected[type] === undefined) {
						_selected[type] = [];
					}
					_selected[type].push(item_id);

					// setTimeout(function clearRecipientSearch() {
						$self.val('');
					// }, 100);
					// _insert_on_blur = false;

					if (hasHighlight) {
						self._addRecipientLabel(item_id, label, type, score);
					} else {
						self._addRecipientLabel(item_id, label, type);
					}

					self._addTextRecipients(item_id);
				},
				function template(item) {
					var val = item.name;

					if (type === 'all' && typeof item.type !== 'undefined') {
						val = item.type.charAt(0).toUpperCase()+item.type.slice(1) + ' - '+val;
					}

					return val;
				},
				function matcher(item) {
					if ($.inArray(item.id, _selected[item.type]) > -1) {
						return false;
					}

					return true;
				}
			);

			this.$el.on('click', '.remove', function remove()
			{
				var $self = $(this),
				    $input,
				    type,
				    // extract the type from the input name
				    type_regex = self.form_name.replace(/([\[\]])/g, "\\$1")+"(?:\\]?)\\[([\\w\\-]+)\\]";

				// remove recipient from internal tracking
				$input = $self.siblings('input');
				type   = $input.prop('name').match(type_regex)[1];

				if (_selected[type] !== undefined) {
					_selected[type].splice(_selected[type].indexOf($input.val()), 1);
				}

				$self.parents('.recipient').remove();

				if (self.$el.find('.recipient').length <= 2) {
					self.$el.trigger('adz.recipients.empty');
				}

				// remove from the multiselect too
				if (self.multiselect_visible) {
					self.$multiselect.find('option[value="'+$input.val()+'"]').prop('selected', false);
					self.$multiselect.selectpicker('refresh');
				}

				if (self.text_recipients.length > 0) {
					self.text_recipients = self.text_recipients.filter(function removeFromTextRecipients(item) {
						return item !== $input.val();
					});

					self._showHideTextRecipients();
				}
			});

			this.$el.on('click', '.remove-all', function removeAll()
			{
				$(this).parents('.recipients')
				     .find('.recipient')
				     .not('#remove-all')
				     .not('.template')
				     .remove();

				_selected = {};

				if (self.$el.find('.recipient').length <= 2) {
					self.$selected_recipients.addClass('hidden');
					self.$el.trigger('adz.recipients.empty');
				}

				// empty out the array and remove all
				if (self.text_recipients.length > 0) {
					self.text_recipients.length = 0;
					self._showHideTextRecipients();
				}
			});

			this.$el.on('blur', 'input[type="text"].search', function selectOnBlur()
			{
				$(this).val('');
				// var $self = $(this),
				//     email = $self.val();

				// setTimeout(function waitToSelectOnBlur() {
				// 	if (_insert_on_blur) {
				// 		_insert_on_blur = false;
				// 		self._addRecipientLabel(email, email, 'manual_email');
				// 		$self.val('');
				// 	}
				// }, 100);
			});

			this.$el.on('adz.recipients.empty', function empty()
			{
				self.$selected_recipients.addClass('hidden');
				if (self.multiselect_visible) {
					self.$multiselect.selectpicker('deselectAll');
				}
			});

			this.$search_type.on('change', function typeChanged()
			{
				self.search_type       = this.value;
				self.search_type_title = this.options[this.selectedIndex].text;

				if (Object.keys(data_urls).indexOf(this.value) >= 0) {
					self._initMultiselect(self.search_type);
					self.$multiselect_toggle.removeClass('hidden');
					self._updateToggleText();
				}
				else if (!self.$multiselect_toggle.hasClass('hidden')) {
					self.$multiselect_toggle.addClass('hidden');

					if (self.multiselect_visible) {
						self._toggleMultiselectVisibility();
					}
				}
			});

			this.$multiselect_toggle.on('click', function toggleSelect()
			{
				event.preventDefault();
				self._toggleMultiselectVisibility();
			});
		}
		catch (err) {
			console.log('[Adzuki.RecipientSelection]', err);
		}
	};

	recipientSelection.prototype._addRecipientLabel = function _addRecipientLabel(id, label, type, score = null)
	{
		var $recipient = this.$recipient_template.clone();
		$recipient.removeClass('template');
		$recipient.find('input').val(id).attr('name', this.form_name + '['+type+'][]');
		$recipient.find('.title').html(label);
		$recipient.addClass(this.search_type+' '+id);
		$recipient.appendTo(this.$selected_recipients.find('.recipients'));

		if (score) {
			if (score >= 1 && score <= 2) {
				$recipient.css('background-color', '#d2e9cf');
			} else if (score >= 3 && score <= 6) {
				$recipient.css('background-color', '#fcf8e3');
			} else if (score === '7') {
				$recipient.css('background-color', '#f2dede');
			}
		}

		if (this.$selected_recipients.hasClass('hidden')) {
			this.$selected_recipients.removeClass('hidden');
		}

		if ($('#link_video_button').length) {
			$('#link_video_button').prop('disabled', false);
		}
	};

	recipientSelection.prototype._addTextRecipients = function _addTextRecipients(id)
	{
		var self          = this;
		var text_type     = $('.texting-selection').data('text-type');
		var text_pref_key = 'mobile_receive_texts';

		if (text_type) {
			if (text_type === 'travel_reminders') {
				text_pref_key = 'mobile_receive_travel_texts';
			} else if (text_type === 'trip_summaries') {
				text_pref_key = 'mobile_receive_fit_builder_texts';
			}
		}

		if ($('.texting-selection').length > 0) {
			Adzuki.Ajax.get(Adzuki.base_uri + '/Clients/getTextingPreference/' + id)
			.then(function _affectRecipients(data) {
				if (parseInt(data[text_pref_key]) > 0) {
					self.text_recipients.push(id);
					self._showHideTextRecipients();
				}
			});
		}
	};

	recipientSelection.prototype._showHideTextRecipients = function _showHideTextRecipients()
	{
		var client_ids = null;
		var url        = null;
		var req_data   = {};
		var form_name  = $('.texting-selection').data('form-name');
		var item_id    = $('.texting-selection').data('item-id');
		var message    = $('#text-recipients-message').val();

		if (message === undefined) {
			// loading the page for the first time
			// if there's an existing message from the server, use that
			message = $('#text-recipients-existing-message').val();
		}

		if (this.text_recipients.length > 0) {
			$('.texting-selection').removeClass('hidden');

			client_ids = this.text_recipients.toString();
			url        = Adzuki.base_uri + '/Clients/textRecipients';

			req_data.client_ids = client_ids;
			req_data.form_name  = form_name;

			if (item_id) {
				req_data.item_id = item_id;
			}

			this._showSendTextButton(form_name);

			Adzuki.Ajax.post(url, req_data).then(function _getTextRecipientTable(response) {
				if (response.error === true) {
					alert(response.message);
				} else {
					$('.text-recipients').html(response);

					if (message) {
						$('#text-recipients-message').val(message);
					}

					Adzuki.CharacterCount($('#text-recipients-message'), {
						max  : 200,
						label: '.text-recipient-message-count',
					});
				}
			});
		} else {
			$('.text-recipients').html('');
			$('.texting-selection').addClass('hidden');

			this._hideSendTextButton(form_name);
		}
	};

	recipientSelection.prototype._initMultiselect = function _initMultiselect(type)
	{
		var self = this;

		if (cache[type] === undefined) {
			Adzuki.Ajax.get(Adzuki.base_uri + data_urls[type])
			.then(function _getMultiselectData(data) {
				cache[type] = data;
				self._populateMultiselect(type, data);
			});
		}
		else {
			self._populateMultiselect(type, cache[type]);
		}

		// only init once
		if (this.$multiselect.data('adzuki-init') === undefined)
		{
			this.$multiselect.on('changed.bs.select', function _selectedMultiselectOpt(e)
			{
				var selected_values = $(e.target).val();
				self.$selected_recipients.find('.recipient.'+self.search_type).remove();

				selected_values.forEach(function _addRecipientFromMultiselect(id)
				{
					var $opt     = $(e.target).find('option[value="'+id+'"]'),
					    opt_type = $opt.data('type'),
					    label    = '<b>' + Adzuki.String.ucwords(opt_type.replace('_', ' ')) + ':</b> ' + $opt[0].text;

					opt_type = opt_type.toLowerCase().replace(/\s/g, '-');
					self._addRecipientLabel(id, label, opt_type);
				});

				if (self.$el.find('.recipient').length <= 2) {
					self.$el.trigger('adz.recipients.empty');
				}
			});

			this.$multiselect.data('adzuki-init', true);
		}
	};

	recipientSelection.prototype._populateMultiselect = function _populateMultiselect(type, data)
	{
		var self = this,
		    opts = [];

		// source needs to be split up into the My and Global groups
		// set this to always fail as sources will be a single list to be consistent with the others (Phill asked for this and then changed his mind)
		if (type === 'source' && 1===2)
		{
			opts.push('<optgroup label="My Sources">');
			data.my.forEach(function __populateSourceMy(source) {
				opts.push(_getOptHtml({
					type: 'source',
					id  : source.id,
					name: source.name + ' (' + source.total_clients + ')',
				}));
			});
			opts.push('</optgroup>');

			opts.push('<optgroup label="Global Sources">');
			data.global.forEach(function __populateSourceGlobal(source) {
				opts.push(_getOptHtml({
					type: 'source',
					id  : source.id,
					name: source.name,
				}));
			});
			opts.push('</optgroup>');
		}
		// all others are generic
		else {
			data.forEach(function __populateItem(item) {
				opts.push(_getOptHtml(item));
			});
		}

		this.$multiselect.html(opts.join(''));
		this.$multiselect.selectpicker('refresh');


		function _getOptHtml(item)
		{
			var selected = '';

			if (self.$selected_recipients.find('.recipients .recipient.'+item.type+'.'+item.id).length) {
				selected = 'selected';
			}

			return '<option value="'+item.id+'" data-type="'+item.type+'" '+selected+'>'+item.name+'</option>';
		}
	};

	recipientSelection.prototype._toggleMultiselectVisibility = function _toggleMultiselectVisibility()
	{
		var $multiselect = this.$multiselect_toggle.siblings('span'),
		    $typeahead   = this.$multiselect_toggle.siblings('input');

		$multiselect.toggleClass('hidden', !$multiselect.hasClass('hidden'));
		$typeahead.toggleClass('hidden', !$typeahead.hasClass('hidden'));

		if (cache[this.search_type] !== undefined) {
			this._populateMultiselect(this.search_type, cache[this.search_type]);
		}

		this.multiselect_visible = !this.multiselect_visible;
		this._updateToggleText();
	};

	recipientSelection.prototype._updateToggleText = function _updateToggleText()
	{
		var toggle_text;

		if (this.multiselect_visible) {
			toggle_text = 'Search for ' + this.search_type_title;
		} else {
			toggle_text = 'Select from ' + this.search_type_title + ' list';
		}

		this.$multiselect_toggle.html(toggle_text);
	};

	recipientSelection.prototype._showSendTextButton = function _showSendTextButton(form_name)
	{
		switch (form_name) {
			case 'CruiseSheetPrepare':
				// send text button for the cruise sheet form
				$('.send-cruise-sheet-text').removeClass('hidden');
			break;
			case 'ReservationGenerateInvoice':
				// for the reservation invoice form, add the button to send
				// the invoice only via text message
				$('a.btn.send-text-btn').removeClass('hidden');
			break;
			case 'AllInclusivePropertySheetBuildPreview':
				$('.send-aip-sheet-text').removeClass('hidden');
			break;
			case 'TourSheetsEdit':
				$('.send-tour-sheet-text').removeClass('hidden');
			break;
			default:
				// make the linter happy
		}
	};

	recipientSelection.prototype._hideSendTextButton = function _hideSendTextButton(form_name)
	{
		switch (form_name) {
			case 'CruiseSheetPrepare':
				// send text button for the cruise sheet form
				$('.send-cruise-sheet-text').addClass('hidden');
			break;
			case 'ReservationGenerateInvoice':
				// for the reservation invoice form, remove the button to send
				// the invoice only via text message
				$('a.btn.send-email-btn').addClass('border-round-right');
				$('a.btn.send-text-btn').addClass('hidden').removeClass('border-round-right');
			break;
			case 'AllInclusivePropertySheetBuildPreview':
				$('.send-aip-sheet-text').addClass('hidden');
			break;
			case 'TourSheetsEdit':
				$('.send-tour-sheet-text').addClass('hidden');
			break;
			default:
				// make the linter happy
		}
	};

	Adzuki.RecipientSelection = recipientSelection;
}(jQuery, window.Adzuki || {}));
